import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';
import { InventoryReportTypeEnum } from 'types/inventory';

// Create styles
const styles = StyleSheet.create({
  row: {
    width: '100%',
    flexDirection: 'row',
  },
  cell: {
    color: '#53575A',
    fontFamily: 'Trebuchet',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    fontSize: 11,
    borderRight: '1px solid #BABABA',
    width: 78,
    height: 35,
    backgroundColor: '#FFFCE8',
    fontWeight: 'bold',
  },
});

const InvoiceTableHeadRow = ({ reportType }: { reportType: any }) => (
  <View style={styles.row}>
    <View style={styles.cell}>
      <Text>Item</Text>
    </View>
    <View style={styles.cell}>
      <Text>Lost</Text>
    </View>
    <View style={styles.cell}>
      <Text>Replacement</Text>
      <Text>Fee</Text>
    </View>
    <View style={styles.cell}>
      <Text>Total Lost</Text>
      <Text>Fees</Text>
    </View>
    {reportType === InventoryReportTypeEnum.NO_INVENTORY && (
      <>
        <View style={styles.cell}>
          <Text>Used</Text>
        </View>
        <View style={styles.cell}>
          <Text>Used Fee</Text>
        </View>
        <View
          style={{
            ...styles.cell,
            borderRight: 0,
          }}>
          <Text>Total</Text>
          <Text>Used Fees</Text>
        </View>
      </>
    )}
  </View>
);

export default InvoiceTableHeadRow;
